export interface TrackingEvent {
  category: string;
  action: string;
  name?: string;
  value?: number;
}

export function isTrackingEvent(value: unknown): value is TrackingEvent {
  return (
    typeof value === 'object' &&
    value !== null &&
    'category' in value &&
    typeof value.category === 'string' &&
    'action' in value &&
    typeof value.action === 'string' &&
    (!('name' in value) || value.name === undefined || typeof value.name === 'string') &&
    (!('value' in value) || value.value === undefined || typeof value.value === 'number')
  );
}
